<template>
  <div class="radio-buttons">
    <div
      class="radio-button"
      v-for="item in items"
    >
      <input
        class="radio-button__input"
        type="radio"
        :id="`radio-button${item.key}`"
        @keyup.enter="select(item)"
        @click="select(item)"
        :checked="modelValue?.key === item.key"
      >
      <label
        class="radio-button__label"
        :for="`radio-button${item.key}`"
      >
        <i
          v-if="item.metadata.icon"
          :class="item.metadata.icon"
        ></i>
        <div>{{ item.text }}</div>
      </label>
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import type { IDmComponentsItem } from '~/models/components';

interface IProps {
  items: IDmComponentsItem[];
  modelValue: IDmComponentsItem | null;
}

interface IDmRadioButtonEmits {
  (name: 'update:modelValue', item: IDmComponentsItem): void;
}

// emits
const emits = defineEmits<IDmRadioButtonEmits>();

// props
const props = defineProps<IProps>();


// methods 
const select = (item: IDmComponentsItem) => {
  emits('update:modelValue', item);
}

</script>

<style lang="scss">
.radio-buttons {
  display: flex;
  justify-content: center;
  height: auto;
  background-color: $grey-6;
  border-radius: 10px;
  padding: 4px;
  gap: 10px;

  @media (min-width: $breakpoint) {
    padding: 6px;
  }
}

.radio-button {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &:not(:last-child) {
    &::after {
      content: '';
      position: absolute;
      width: 2px;
      right: -6px;
      background: $grey-4;
      top: 5px;
      border-radius: 1px;
      bottom: 5px;
    }
  }

  &__input {
    width: 0;
    height: 0;
    opacity: 0;
    margin: 0;


    &:checked {
      ~.radio-button__label {
        color: $white !important;
        background-color: $blue-1;
        box-shadow: 2px 2px 6px 0 #D3D6DD;

        i {
          background: $white;
        }
      }
    }

    &:focus {
      ~.radio-button__label {
        color: $black;
        border: 2px solid $black;
        transition: all 0.2s ease-in-out;
      }
    }
  }

  &__label {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.2s ease-in-out;
    border: 2px solid transparent;
    box-sizing: border-box;
    cursor: pointer;
    gap: 0 4px;
    height: 38px;

    @media (min-width: $breakpoint) {
      height: 44px;
    }

    i {
      background: $black;
    }
  }
}
</style>